import React, {Component} from 'react';
import './styles.css';
import CardHelper from '../../helpers';
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardInfinite extends Component {
  constructor(props) {
    super(props);
    this.state = { imageReady: !_isPS4 };
    this._coverRef = null;
    this._loadTimer = null;

    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache
    this._cachedBadge = null;
    this._cachedTitle = null;
    this._cachedCoverStyle = null;
    this._prevBadges = undefined;
    this._prevTitle = undefined;
    this._prevProvider = undefined;
    this._prevLiveEnabled = undefined;
    this._prevCover = undefined;
    this._prevImageReady = undefined;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.cover !== nextProps.cover ||
      this.props.badges !== nextProps.badges ||
      this.props.title !== nextProps.title ||
      this.props.classOutLineFocus !== nextProps.classOutLineFocus ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedBadge = null;
    this._cachedTitle = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  _updateCachedElements() {
    const props = this.props;
    const cover = props.cover;
    const badges = props.badges;
    const title = props.title;
    const imageReady = this.state.imageReady;
    const provider = props.provider || '';
    const liveEnabled = props.live_enabled || '0';

    if (cover !== this._prevCover || imageReady !== this._prevImageReady) {
      this._prevCover = cover;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(cover, imageReady);
    }

    if (badges !== this._prevBadges) {
      this._prevBadges = badges;
      this._cachedBadge = CardHelper.createBadge(badges);
    }

    if (title !== this._prevTitle || provider !== this._prevProvider || liveEnabled !== this._prevLiveEnabled) {
      this._prevTitle = title;
      this._prevProvider = provider;
      this._prevLiveEnabled = liveEnabled;
      const isTitleEnabled = CardHelper.posterTitleIsEnabled(provider);
      this._cachedTitle = CardHelper.createTitle(title, isTitleEnabled, liveEnabled === '1');
    }
  }

  render() {
    this._updateCachedElements();

    const cover = this.props.cover;
    const classOutLineFocus = this.props.classOutLineFocus;

    return (
      <div className={'card card-infinite'}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            {cover !== '' &&
            <div
              ref={this._setCoverRef}
              className={'card-cover ' + (classOutLineFocus || '')}
              style={this._cachedCoverStyle}
            />
            }
            {this._cachedBadge}
            <div className='card-labels-container'>
              {this._cachedTitle}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CardInfinite;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardInfinite/index.js